import { defineComponent as _defineComponent } from 'vue'
import {onBeforeMount, ref} from 'vue';
import config from '@/config';
import userStoreModule from '@/store/modules/user';
import {getProductDetail, login, getDetailImage, getContact} from '@/api/miscellaneous';
import moment from 'moment';
import {useRoute, useRouter} from 'vue-router';
import {Dialog, Toast} from 'vant';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuotedDetail',
  setup(__props, { expose }) {
  expose();

const images = ref<any[]>([]);
const route = useRoute();
const router = useRouter();
const detail = ref<any>({});

const restrictShow = ref(false);
const restrictCode = ref('');
const tel = ref('');
const isShowTel = ref(false);

const isDoesNotExist = ref(false);
onBeforeMount(() => {
    // if (userStoreModule.token) {
    let {id, state} = route.query;
    getDetail((state || id) as string);
    // } else {
    //     isLogin();
    // }
});

const isLogin = (): void => {
    let {code, id, state} = route.query;
    if (!code) {
        /**
         * 微信登录Code授权
         * 重定向页面还是这个页面，通过$roter.query.code 判断是否是重定向回来的
         * */
        const redirectUri = encodeURIComponent(`${config.webHost}${window.location.pathname}`);
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
            config.wechat.appid
        }&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_userinfo&state=${id || 'STATE'}#wechat_redirect`;
    } else {
        login({code: code as string}).then(res => {
            let {token, encrypt} = res;
            userStoreModule.setToken(token);
            userStoreModule.setEncrypt(encrypt);
            getDetail((state || id) as string);
        });
    }
};
const getDetail = (itemid?: string): void => {
    let id = itemid || (route.query.id as string) || '';
    getProductDetail({id}).then(res => {
        if (res.online) {
            detail.value = res;
        } else {
            isDoesNotExist.value = true;
        }
    });
    getImage();
};
const getImage = (itemid?: string): void => {
    let id = itemid || (route.query.id as string) || '';
    getDetailImage({id}).then(res => {
        images.value = res as any[];
    });
};

const jumpToUrl = (url: string): void => {
    window.location.href = url;
};

const getTel = (): void => {
    let id = (route.query.id as string) || '';
    getContact({id})
        .then(res => {
            tel.value = res;
            isShowTel.value = true;
        })
        .catch(e => {
            let {code} = e;
            if ([104, 107].includes(code)) {
                restrictCode.value = code;
                restrictShow.value = true;
            }
        });
};

const toQuotedPrice = (): void => {
    if (detail.value.state === 4) Toast('');
    else router.push({name: 'QuotedPrice', query: {id: route.query.id}});
};

const __returned__ = { images, route, router, detail, restrictShow, restrictCode, tel, isShowTel, isDoesNotExist, isLogin, getDetail, getImage, jumpToUrl, getTel, toQuotedPrice, onBeforeMount, ref, config, userStoreModule, getProductDetail, login, getDetailImage, getContact, moment, useRoute, useRouter, Dialog, Toast }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})